export const readConsent = () => {
  try {
    return JSON.parse(localStorage.getItem("obsidian_consent"));
  } catch {
    return null;
  }
};

export const writeConsent = (consent) => {
  localStorage.setItem(
    "obsidian_consent",
    JSON.stringify({ ...consent, ts: Date.now() })
  );
  window.dispatchEvent(new Event("obsidian-consent"));
};

let gaLoaded = false;

export const tryLoadGA4 = (content) => {
  const id = content && content.ga_measurement_id;
  if (!id || gaLoaded) return;
  const consent = readConsent();
  if (!consent || !consent.analytics) return;
  gaLoaded = true;
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  window.gtag = function () {
    window.dataLayer.push(arguments);
  };
  window.gtag("js", new Date());
  window.gtag("config", id, { anonymize_ip: true });
};
